import billingsTaxiUnbilledOrderListingRouteQueryParamsService from "../../common/billings-taxi-unbilled-order-listing-route-query-params.service";
import BillingsTaxiUnbilledOrderListingFilter from "../../common/types/billings-taxi-unbilled-order-listing-filter";
import BillingsTaxiUnbilledOrderListingSortKey from "../../common/types/billings-taxi-unbilled-order-listing-sort-key";
import BillingsTaxiUnbilledOrderListingByTaxiRouteQueryParams from "./types/billings-taxi-unbilled-order-listing-by-taxi-route-query-params";

const createRouteQueryParams = (
  filters: BillingsTaxiUnbilledOrderListingFilter[],
  sortKey: BillingsTaxiUnbilledOrderListingSortKey | null,
  page: number,
  pageSize: number
): BillingsTaxiUnbilledOrderListingByTaxiRouteQueryParams => {
  const routeQueryParams: BillingsTaxiUnbilledOrderListingByTaxiRouteQueryParams =
    billingsTaxiUnbilledOrderListingRouteQueryParamsService.createRouteQueryParams(
      filters,
      sortKey,
      page,
      pageSize
    );

  return routeQueryParams;
};

const billingsTaxiUnbilledOrderListingByTaxiRouteQueryParamsService = {
  getFilters:
    billingsTaxiUnbilledOrderListingRouteQueryParamsService.getFilters,
  getSortKey:
    billingsTaxiUnbilledOrderListingRouteQueryParamsService.getSortKey,
  getPage: billingsTaxiUnbilledOrderListingRouteQueryParamsService.getPage,
  getPageSize:
    billingsTaxiUnbilledOrderListingRouteQueryParamsService.getPageSize,
  createRouteQueryParams,
};

export default billingsTaxiUnbilledOrderListingByTaxiRouteQueryParamsService;
